import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAlert } from 'react-alert'

import { Card, RightAlignedButton } from "../../common_components/Layout";
import { CardTitle } from "../../create_mission_components/components/TitleAndText";
import { PrimaryButton } from "../../common_components/Buttons";
import SubHeader from "../../missions_components/SubHeader";
import { MissionPageContainer } from "../../common_components/Layout";
import SurveyCreatorWidget from "./SurveyCreatorWidget";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { PurpleMissionLiveWarningModal } from "../../common_components/PurpleModals";


// Api Calls
import SurveyAPI from "../../../api/api_calls/SurveyAPI";
import CreateSurveyCreator from "./CreateSurveyCreator";


function SurveyCreate(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const location = useLocation();

    const [afterSavePath, setAfterSavePath] = useState(`/missions/${missionId}/survey`);

    const [surveyLoading, setSurveyLoading] = useState(true);
    const [surveyJson, setSurveyJson] = useState({});
    const [originalSurveySaveNo, setOriginalSurveySaveNo] = useState(0);
    const [currentSaveNo, setCurrentSaveNo] = useState(0);
    const [surveyCreator, setSurveyCreator] = useState(null);

    const pageTitle = props.isScreener ? "Edit Screener" : "Edit Survey";
    const cardTitle = props.isScreener ? "Creating your Screener" : "Creating your Survey";
    const cardText = props.isScreener ?
        "Welcome to despark’s screener editor. Create your screener below. You can decide which questions should admit or kick out respondents by using the “Screener Logic” section. Select a question, and it will appear as an option in the panel on the right."
        :
        "Welcome to despark’s survey editor. Create your survey below. Questions on how to do something?  Contact us at info@despark.io.";

    //Mission is Live Modal
    const [warningModalIsOpen, setWarningModalIsOpen] = useState(false);
    const toggleModal = () => {
        setWarningModalIsOpen(!warningModalIsOpen);
    }


    // If you use a web service:
    function saveSurveyJson(json, saveNo, callback) {

        async function callUpdateSurveyApi() {
            if (props.isScreener) {
                return await SurveyAPI.createOrUpdateScreener({ missionId: missionId, surveyJson: json, saveId: saveNo, handleRedirect: navigate });
            } else {
                return await SurveyAPI.createOrUpdateSurvey({ missionId: missionId, surveyJson: json, saveId: saveNo, handleRedirect: navigate });
            }
        }

        async function saveSurvey() {
            const response = await callUpdateSurveyApi();

            if (response.success) {
                // console.log("Completed save! Save Number: " + saveNo)
                setCurrentSaveNo(saveNo);
                callback(saveNo, true);
            } else {
                // console.log("Failed save! Save Number: " + saveNo)
                callback(saveNo, false);
            }
        }

        if (json && Object.keys(json).length > 0 && saveNo > currentSaveNo) {
            saveSurvey();
        } else {
            // console.log("Dup save number - saying it's failed!")
            callback(saveNo, false);
        }
    }


    useEffect(() => {

        async function callSurveyAPI() {
            if (props.isScreener) {
                return await SurveyAPI.showScreener({ missionId: missionId, handleRedirect: navigate });
            } else {
                return await SurveyAPI.showSurvey({ missionId: missionId, handleRedirect: navigate });
            }
        }

        async function getSurvey() {
            const response = await callSurveyAPI();
            if (response.success) {

                if (response.survey_exists) {
                    setSurveyJson(response.survey_json);
                    setOriginalSurveySaveNo(response.save_no + 1);
                    setCurrentSaveNo(response.save_no + 1); // Add one so that we can save the next version.
                    const creator = CreateSurveyCreator(response.survey_json, response.save_no + 1, saveSurveyJson, props.isScreener, missionId)
                    setSurveyCreator(creator)
                    setSurveyLoading(false);
                } else {
                    setSurveyJson({});
                    setOriginalSurveySaveNo(0);
                    setCurrentSaveNo(0);
                    const creator = CreateSurveyCreator({}, 0, saveSurveyJson, props.isScreener, missionId)
                    setSurveyCreator(creator)
                    setSurveyLoading(false);
                }
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        // Set the path for the button if there's a direct link.
        // No longer doing this - always rely on mission status.
        // if (location.state) {
        //     setAfterSavePath(location.state.afterSavePath || `/missions/${missionId}`);
        // }
        getSurvey();
    }, [])

    // Make sure we've got a path for the buttons. In case the location.state isn't set due to a direct link.
    useEffect(() => {
        const surveyTypePath = props.isScreener ? "audience" : "survey";
        const statusBackPath = props.missionStatus == "draft" ? `/createmission/${missionId}/${surveyTypePath}` : `/missions/${missionId}`;
        setAfterSavePath(statusBackPath);
        if (props.missionStatus !== undefined && props.missionStatus != "draft") {
            setWarningModalIsOpen(true);
        }
    }, [props.missionStatus])


    return (
        <>
            {surveyLoading ? <CenteredLoadingIcon /> :
                <>
                    <SubHeader title={pageTitle} />
                    <MissionPageContainer>
                        <Card style={{ flexGrow: 1 }} >
                            {/* <div className="session-details-container"> */}
                            <CardTitle >
                                {cardTitle}
                            </CardTitle>
                            <div className="survey-card-overview-text-container">
                                <div className="create-mission-card-text">
                                    {cardText}
                                </div>

                            </div>
                            <PrimaryButton text="Save & Go Back" onClick={() => navigate(afterSavePath)} />
                        </Card>
                        <SurveyCreatorWidget creator={surveyCreator} />
                        {/* <Card style={{ flexGrow: 1 }} > */}
                        <RightAlignedButton>
                            <PrimaryButton text="Save & Go Back" onClick={() => navigate(afterSavePath)} submitLoading={false} />
                        </RightAlignedButton>
                        {/* </Card> */}

                    </MissionPageContainer>
                    <PurpleMissionLiveWarningModal isOpen={warningModalIsOpen} toggleModal={toggleModal} onCancel={() => navigate(afterSavePath)} />
                </>
            }
        </>


    )
}


export default SurveyCreate;